import React, { useState } from 'react';
import { twMerge } from 'tailwind-merge';

export default function Tooltip({ 
  content, 
  children, 
  position = 'top',
  className = '',
  disabled = false
}) {
  const [isVisible, setIsVisible] = useState(false);
  
  const positions = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2'
  };

  if (disabled || !content) {
    return children;
  }

  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      >
        {children}
      </div>
      
      {isVisible && (
        <div className={twMerge(
          'absolute z-10 px-2 py-1 text-xs font-medium text-white bg-midnight rounded-md shadow-lg whitespace-nowrap',
          positions[position],
          className
        )}>
          {content}
          <div className={`
            absolute w-2 h-2 bg-midnight transform rotate-45
            ${position === 'top' ? 'bottom-[-4px] left-1/2 -translate-x-1/2' : ''}
            ${position === 'bottom' ? 'top-[-4px] left-1/2 -translate-x-1/2' : ''}
            ${position === 'left' ? 'right-[-4px] top-1/2 -translate-y-1/2' : ''}
            ${position === 'right' ? 'left-[-4px] top-1/2 -translate-y-1/2' : ''}
          `} />
        </div>
      )}
    </div>
  );
}